import React, { useEffect } from "react"
import { Button } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux"
import { getStripeDashboardLinkAsync } from "../../SupplierPayment/supplierPaymentSlice"
import { RootState } from "typesafe-actions"


export default function StripeDashboardButton() {
    const dispatch = useDispatch()
    const _supplierPayment = useSelector((state: RootState) => state.supplierPaymentRdc)
    useEffect(() => {
        if (_supplierPayment.stripeDashboardLink)
            window.open(_supplierPayment.stripeDashboardLink!)
    }, [_supplierPayment.stripeDashboardLink])

    return (
        <Button color="primary" onClick={() => { dispatch(getStripeDashboardLinkAsync()) }} variant="contained" >Edit payout details</Button>
    )
}